import React from 'react';
import Logo from '../assets/icons/Logo'; 
import SmartPart from '../assets/images/SmartPart.png';

const Header = ({  }) => {

  return (
    <header style={styles.navbar}>
      <div style={styles.logoContainer}> 
<Logo />
        <img src={SmartPart} alt="SmartPart" style={styles.logoText} />
      </div>

    </header>
  );
};

export default Header;

const styles = {
  navbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 40px',
    backgroundColor: '#333333',
    borderBottom: '1px solid #2a2a2a',
    position: 'fixed',
    top: 0,
    left: 0, 
    right: 0,
    zIndex: 1000,
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 20,
  },

  logoText: {
    height: 32,
  },
  stepInfo: {
    textAlign: 'center',
    color: '#fff',
  },
  stepTitle: {
    fontFamily: 'sans-serif',
    fontSize: '24px',
    fontWeight: '500',
  },
};
